export { ANGXStockTicker } from './ANGXStockTicker'
